import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sd-training-videos',
  templateUrl: './training-videos.component.html',
  styleUrls: ['./training-videos.component.scss']
})
export class TrainingVideosComponent implements OnInit {
  constructor(){}

  ngOnInit() {
  }
}
